import React, { useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Button,
  Tooltip,
  useTheme,
  useMediaQuery,
  Fade,
  Menu,
  Grid
} from '@mui/material';
import {
  ChevronLeft,
  ChevronRight,
  CalendarMonth,
  Today,
  ViewWeek,
  ViewDay,
  ViewModule,
  
  KeyboardArrowDown
} from '@mui/icons-material';
import { PapiroConsole } from 'src/utils/papiroConsole';

const CalendarHeader = ({
  currentDate,
  monthNames,
  view,
  setView,
  prevMonth,
  nextMonth,
  goToToday,
  setCurrentDate,
  onDateChange,
  selectMonthCalendar,
  setSelectedYear,
  selectedYear
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  // const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    // Reset view to months when opening
    setView('months');
    setSelectedYear(currentDate.getFullYear());
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  // Função para mudar para visualização de anos
  const showYearView = () => {
    setView('years');
  };
  
  // Função para selecionar um ano
  const selectYear = (year) => {
    PapiroConsole.log("entrei aqui 1234")
    setSelectedYear(year);
    setView('months');
  };

  const generateYears = () => {
    const currentYear = currentDate.getFullYear();
    const years = [];
    for (let i = currentYear - 5; i <= currentYear + 5; i++) {
      years.push(i);
    }
    return years;
  };

  const selectMonth = (monthIndex) => {
    // const newDate = new Date(currentDate);
    // newDate.setFullYear(selectedYear);
    // newDate.setMonth(monthIndex);
    // setCurrentDate(newDate);
    // if (onDateChange) onDateChange(newDate);
    // handleClose();
    selectMonthCalendar(monthIndex)
    handleClose();
    
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'flex-start' : 'center',
        justifyContent: 'space-between',
        mb: 3,
        gap: 2
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <CalendarMonth sx={{ mr: 1, color: theme.palette.primary.main }} />
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Calendário de Tickets
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 1
        }}
      >
        <Button
          variant="contained"
          size="small"
          onClick={goToToday}
          startIcon={<Today />}
        >
          Hoje
        </Button>

        {/* <Box sx={{ display: 'flex', alignItems: 'center', mx: 1 }}>
          <IconButton onClick={prevMonth} size="small">
            <ChevronLeft />
          </IconButton>
          
          <Typography variant="h6" sx={{ px: 1, minWidth: isMobile ? 'auto' : 140, textAlign: 'center' }}>
            {monthNames[currentMonth]} {currentYear}
          </Typography>
          
          <IconButton onClick={nextMonth} size="small">
            <ChevronRight />
          </IconButton>
        </Box> */}

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton onClick={prevMonth}>
            <ChevronLeft />
          </IconButton>

          <Button
            onClick={handleClick}
            sx={{
              px: 2,
              color: 'text.primary',
              fontWeight: 'medium',
              textTransform: 'none',
              '&:hover': { bgcolor: 'transparent' },
              display: 'flex',
              alignItems: 'center'
            }}
            
          >
            <Typography variant="h6" sx={{ px: 2 }}>
              {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
            </Typography>
          </Button>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
            PaperProps={{
              sx: {
                width: 320,
                maxHeight: 380,
                borderRadius: 2,
                boxShadow: 3
              }
            }}
          >
            {view === 'months' ? (
              <>
                {/* Header com o ano selecionado */}
                <Box
                  sx={{
                    p: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: 1,
                    borderColor: 'divider'
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    Selecione o mês
                  </Typography>
                  <Button
                    variant="text"
                    color="primary"
                    onClick={showYearView}
                    sx={{ fontWeight: 'medium' }}
                  >
                    {selectedYear} ▾
                  </Button>
                </Box>

                {/* Grade de meses */}
                <Grid container spacing={1} sx={{ p: 2 }}>
                  {monthNames.map((month, index) => (
                    <Grid item xs={4} key={month}>
                      <Button
                        fullWidth
                        variant={index === currentDate.getMonth() && selectedYear === currentDate.getFullYear() ? 'contained' : 'text'}
                        color="primary"
                        onClick={() => selectMonth(index)}
                        sx={{
                          borderRadius: 2,
                          py: 1,
                          textTransform: 'none'
                        }}
                      >
                        {month.substring(0, 3)}
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </>
            ) : (
              <>
                {/* Header para seleção de ano */}
                <Box
                  sx={{
                    p: 2,
                    borderBottom: 1,
                    borderColor: 'divider'
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    Selecione o ano
                  </Typography>
                </Box>

                {/* Grade de anos */}
                <Grid container spacing={1} sx={{ p: 2 }}>
                  {generateYears().map((year) => (
                    <Grid item xs={4} key={year}>
                      <Button
                        fullWidth
                        variant={year === currentDate.getFullYear() ? 'contained' : 'text'}
                        color="primary"
                        onClick={() => selectYear(year)}
                        sx={{
                          borderRadius: 2,
                          py: 1
                        }}
                      >
                        {year}
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Menu>

          <IconButton onClick={nextMonth}>
            <ChevronRight />
          </IconButton>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', ml: 1, gap: 1 }}>
          <Tooltip title="Visualização mensal">
            <IconButton
              onClick={() => setView('month')}
              color={view === 'month' ? 'primary' : 'default'}
              size="small"
            >
              <ViewModule />
            </IconButton>
          </Tooltip>

          <Tooltip title="Visualização semanal">
            <IconButton
              onClick={() => setView('week')}
              color={view === 'week' ? 'primary' : 'default'}
              size="small"
            >
              <ViewWeek />
            </IconButton>
          </Tooltip>

          <Tooltip title="Visualização diária">
            <IconButton
              onClick={() => setView('day')}
              color={view === 'day' ? 'primary' : 'default'}
              size="small"
            >
              <ViewDay />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
};

export default CalendarHeader;